import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import DiscordIcon from '../../../svgs/discord.svg'
import TwitterIcon from '../../../svgs/twitter.svg'

const Wrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 1vw;
  padding: 0.4vw 1vw;
  background-color: #36fad7;
`

const MediaIcon = styled.a`
  svg {
    path {
      fill: #111111;
    }
  }
`

const Text = styled.div`
  ${tw`font-primary text-black`}
  font-size: 0.73vw;
  line-height: 114%;
`

const Index: React.FC = () => {
  return (
    <Wrapper>
      <MediaIcon
        href="https://twitter.com/PhalaWorld"
        title="Twitter"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TwitterIcon width="1.7vw" />
      </MediaIcon>
      <MediaIcon
        href="http://discord.gg/phalaworld"
        title="Discord"
        target="_blank"
        rel="noopener noreferrer"
      >
        <DiscordIcon width="1.8vw" />
      </MediaIcon>
      <Text>Communities</Text>
    </Wrapper>
  )
}

export default React.memo(Index)
